import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import Pagination from '../../../interfaces/common/pagination';
import IMenuItem from '../../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../../common/widgets/mainLayout';
import LanguageUtils from '../../../utils/LanguageUtils';
import PageUtils from '../../../utils/pageUtils';
import { fetchReportLines005, resetReportLines005, getReportLines005, isLoadingReportLines005 } from '../../../reducers/reportsReducer';
import Paging from '../../../interfaces/common/paging';
import UrlConstants from '../../../constants/UrlConstants';
import ReportLine005 from '../../../interfaces/output/ReportLine005';
import ReportLine005Filters from '../../../interfaces/filters/reportLine005Filters';
import ReportLine005FilterComponent from './reportLine005FilterComponent';
import ReportLine005List from './reportLine005List';

interface IReportLine005Props {
    reportLine005: Pagination<ReportLine005>;
    classes: any;
    fetchReportLines005: any;
    isLoading: boolean;
    onChange: () => void;
    resetReportLine005: () => void;
    fetch: any;
    match: any;
}

interface IReportLine005State {
    filters: ReportLine005Filters;
    paging: Paging;
    menuItem: IMenuItem;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    reportLine005: LanguageUtils.createMessage('Report Line005')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchReportLines005: (paging: Paging, filters: ReportLine005Filters) => dispatch(fetchReportLines005({
        paging,
        filters
    })),
    resetReportLine005: () => dispatch(resetReportLines005())

});

const mapStoreToProps = (store: RootState) => {
    return {
        resetReportLines005: getReportLines005(store),
        isLoading: isLoadingReportLines005(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ReportLinePage005 extends Component<IReportLine005Props, IReportLine005State> {
    reportLine005ListRef: any;
    constructor(props: IReportLine005Props) {
        super(props);
        this.reportLine005ListRef = React.createRef();

        this.state = {
            filters: {} as ReportLine005Filters,
            menuItem: {
                id: 1,
                name: messages.reportLine005,
                icon: <FontAwesomeIcon icon="warehouse" size="1x" transform="grow-7" />,
                isSelected: false
            },
            // paging: PageUtils.getDefaultPaging([{
            //     field: 'departureYear',
            //     sort: 'asc' as GridSortDirection
            // } as GridSortItem,
            // {
            //     field: 'departureMonth',
            //     sort: 'asc' as GridSortDirection
            // } as GridSortItem]),
            // sortModel: [{
            //     field: 'departureYear',
            //     sort: 'asc' as GridSortDirection
            // } as GridSortItem,
            // {
            //     field: 'departureMonth',
            //     sort: 'asc' as GridSortDirection
            // } as GridSortItem],
            paging: PageUtils.getDefaultPaging([{
                field: 'invoiceYear',
                sort: 'desc'
            } as GridSortItem]),
            sortModel: [{
                field: 'invoiceYear',
                sort: 'desc' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchReportLines005 } = this.props;
        const { paging, filters } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        const newFilter = {
            ...filters,
            reportReconciliateHeader: reportHeader005Id
        } as ReportLine005Filters;

        fetchReportLines005(paging, newFilter);
    }

    componentWillUnmount() {
        const { resetReportLine005 } = this.props;
        resetReportLine005();
    }

    applyFilters = () => {
        const { fetchReportLines005 } = this.props;
        const { paging, filters } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        const newFilter = {
            ...filters,
            reportReconciliateHeader: reportHeader005Id
        } as ReportLine005Filters;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        this.setState({
            paging: newPagination
        });

        fetchReportLines005(newPagination, newFilter);

        if(this.reportLine005ListRef !== null && this.reportLine005ListRef !== undefined &&
            this.reportLine005ListRef.current !== null && this.reportLine005ListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeader005ListRef.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        const newFilter = { ...filters } as ReportLine005Filters;
        (newFilter as any)[attribute] = value;
        newFilter.reportReconciliateHeader = reportHeader005Id;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchReportLines005 } = this.props;
        const { paging } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        const newFilters = {
            reportReconciliateHeader: reportHeader005Id
        } as ReportLine005Filters;

        // const newSortModel = [{
        //     field: 'invoiceYear',
        //     sort: 'desc' as GridSortDirection
        // } as GridSortItem,
        // {
        //     field: 'invoiceMonth',
        //     sort: 'desc' as GridSortDirection
        // } as GridSortItem] as GridSortModel;
        const newSortModel = [{
            field: 'invoiceYear',
            sort: 'desc' as GridSortDirection
        } as GridSortItem];

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        this.setState({
            paging: newPagination,
            filters: newFilters
        });

        fetchReportLines005(newPagination, newFilters);

        if(this.reportLine005ListRef !== null && this.reportLine005ListRef !== undefined &&
            this.reportLine005ListRef.current !== null && this.reportLine005ListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportLine005ListRef.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchReportLines005 } = this.props;
        const { sortModel, filters, paging } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        const newFilter = {
            ...filters,
            reportReconciliateHeader: reportHeader005Id
        } as ReportLine005Filters;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };

            this.setState({
                sortModel: newModel,
                paging: newPaging
            });

            fetchReportLines005(newPaging, newFilter);

        }
    }

    render() {
        const { classes, reportLine005, fetchReportLines005, isLoading } = this.props;
        const { paging, filters, menuItem, columnVisibilityModel } = this.state;
        const { reportHeader005Id } = this.props.match.params;

        return (
            <MainLayout
                menuItem={menuItem}
                routes={
                    [{
                        name: 'go to Reports',
                        url: `${UrlConstants.REPORTS}`
                    }]}>
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ReportLine005FilterComponent
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ReportLine005List rows={reportLine005} isLoading={isLoading}
                                    ref={this.reportLine005ListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        const newFilter = {
                                            ...filters,
                                            reportReconciliateHeader: reportHeader005Id
                                        } as ReportLine005Filters;

                                        fetchReportLines005(newPage, newFilter);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ReportLinePage005));